import React from "react";
import Adminheader from "./Adminheader";
import Adminleft from "./Adminleft";
import Profile from "./Profile";

function Admin() {
  document.title='HR School - Admin'
  return (
    <div>
      <Adminheader/>
      <Adminleft />
     
    </div>
  );
}

export default Admin;
